import { Component, Input, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SideBarItem } from "src/app/flows/flow-node.controller";
import { FlowMenuComponent } from "../../flow-menu/flow-menu.component";

@Component({
  selector: "app-follow-up-node-menu",
  templateUrl: "./follow-up-node-menu.component.html",
  styleUrls: ["./follow-up-node-menu.component.scss"],
})
export class FollowUpNodeMenuComponent
  extends FlowMenuComponent
  implements OnInit
{
  @Input() channelItems!: SideBarItem[];
  onFollowUpNodeSelected!: Subject<SideBarItem>;
  channelItemControl = new FormControl(null, [Validators.required]);
  constructor() {
    super();
  }

  ngOnInit(): void {
    //console.log('FOLLOW UP NODE MENU INIT')
    this.channelItemControl.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((change) => {
        if (change) {
          this.onFollowUpNodeSelected.next(change);
        }
      });
  }
}
